import { User as FireBaseUser } from "firebase/auth";
import { useAuth } from "./AuthContext";

export type User = FireBaseUser;

export const useUser = () => useAuth().user;
